import React,{useEffect, useState,useLayoutEffect} from "react";
import Layout from '../../../Layout/Lighttheme';
import { useLocation } from '@reach/router';
import { Brands } from "../../../Brand";
import { Variant } from "../../../Products";
import Slider from "@mui/material/Slider";
import {getMetaBrand, SearchProduct} from "../../../../service/myProductService";
import ReactPaginate from 'react-paginate';
import { ItemDefaultV2 } from "../../../Products/Item";
import { FromatNumberVIE } from "../../../../utils/format";

const Search =()=>{
    const location = useLocation();
    var param = '';
    try {
        param = decodeURI(location.search?.replace('?', '').replaceAll('=', ''))
      } catch (e) {
        // console.error(e);
      }
      const [scrollPosition, setPosition] = useState(0);
    const [showDes, setShowDes] = useState(false);
    const [range, setRange] = React.useState([0, 100]);
    var [productList, setProductList] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [brand, setBrand] = useState([]);
    const [wd, setWd] = useState(0);
    const loadProductSearch= async(page, per_page, get_brand_info, brand_url_key, min, max)=>{
        try{
            window.localStorage.removeItem('keysearch');
            window.localStorage.setItem('keysearchcurrent', param);
            await SearchProduct(page, per_page,  get_brand_info, brand_url_key, min, max, param).then((response)=>{
                console.log(response);
            if(+response.status===200){
            setMetadata(response['metadata']);
            setProductList(response.message);   
            setMetadata(response['metadata']);
            if(get_brand_info !== ''){
                setBrand(response['brandInfo']);
            }
            
            }
        });
        }catch(e){console.log(e)}
    
    }
    
    useEffect(()=>{
        window.localStorage.setItem('brand_search',JSON.stringify([]));
        window.localStorage.setItem('brands',JSON.stringify([]));
        setProductList([]);
        
        loadProductSearch(0, 20, true, '',0 , 10000000);
        // setWd(document.getElementById("filter").clientWidth);
      },[]);

    const handlePageChange=(event)=>{
        var _perpage = +event.selected+1;
        if(_perpage> 0){
            loadProductSearch(event.selected, 20, true, '');
            window.scrollTo(0,400);
        }
        
      }

     const [brands, setBrands] = useState([]);
     const [brandsearch, setBrandsearch] = useState([]);
     const callBackFunction = (item)=>{
        var _array = JSON.parse(window.localStorage.getItem('brand_search'));
        var _array_brands = JSON.parse(window.localStorage.getItem('brands'));
        var _fg = false;
         if (_array.length > 0) {
            _array?.forEach((data, key) => {
                if (data === item.url_key) {
                    _array.splice(key, 1);
                    document.getElementById(item.url_key).checked = false;
                    _fg = true;
                    _array_brands.splice(key, 1);
                }
            });
        } else {
            _array.push(item.url_key);
            _fg = true;
            _array_brands.push(item);
        }
        if(_fg === false){
            _array.push(item.url_key);
            _array_brands.push(item);
        }
        window.localStorage.setItem('brand_search',JSON.stringify(_array));
        window.localStorage.setItem('brands',JSON.stringify(_array_brands));
        setBrandsearch(_array);
        setBrands(_array_brands);
        // loadProductOnBrand(0, 20, uri);
        loadProductSearch(0, 20, '',  JSON.parse(window.localStorage.getItem('brand_search')),range[0]*100000, range[1]*100000);
     }
     const handleClearAll =()=>{
        var _array = JSON.parse(window.localStorage.getItem('brand_search'));
         if (_array.length > 0) {
            _array?.forEach((data) => {
                    document.getElementById(data).checked = false;
            });
        }
        window.localStorage.setItem('brand_search',JSON.stringify([]));
        window.localStorage.setItem('brands',JSON.stringify([]));
        setBrandsearch([]);
        setBrands([]);
        // loadProductOnBrand(0, 20, uri);
     }

     function handleChanges(event, newValue) {
        setRange(newValue);
        loadProductSearch(0, 20, true, '',newValue[0]*100000, newValue[1]*100000);
     }

    const call = setInterval(() => {
        setShowAlert(true);
        clearInterval(call);
   }, 4000);
    return(
        <Layout>
            <div className="container m-auto p-0">
                <div className="row row--maint m-0 mt-4">
                    {/* <Breadsrumb1 data={breandcrumb}/>
                    {meta?.url_image}
                    {meta?.url_image && meta?.url_image !=='' ? (
                        <div className="col-12 p-0 pb-4"> 
                        <Img imgTitle={meta?.name} url={meta?.url_image} className="banner-cate" style=""/>
                        </div>
                    ):(null)} */}
                </div>
                <div className="row row--maint m-0 p-0">

                    <div className="col-2 p-0 col--left align-items-stretch">
                        <div className="row m-0 me-1">
                            {
                                brands.length > 0 ? (
                                <>
                                <div className="text-end border-1 border-bottom py-2">
                                    <span className="text-gray-400 delete--all" onClick={handleClearAll}>Xóa tất cả <i className="bi bi-trash"></i></span>
                                </div>
                                <div className="text-start border-1 border-bottom py-3 mb-3">
                                    {
                                        brands.map((brand, i)=>{
                                            return <div key={i} className="mb-2" onClick={()=>callBackFunction(brand)}><span className="bg-gray-300 p-2">{brand.name}<i className="bi bi-x fs-5 ms-2"></i></span></div>
                                        })
                                    }
                                </div>
                                </>
                                ):(null)
                                
                            }
                        
                            <div className="col-12 p-0  mb-3 price-rate">
                                
                                <div className="row box-title p-0 m-0">
                                    <div className="col-9"><span >Khoảng giá</span></div>
                                </div>
                                <div className="d-flex justify-content-between my-3">
                                    <span>{FromatNumberVIE(range[0]*100000)}đ</span> <span>{FromatNumberVIE(range[1]*100000)}đ</span>
                                </div>
                                <div className="ps-1 pe-1" >
                                    <Slider className="" value = {range} onChange = {handleChanges}/>
                                </div>
                            </div>
                            
                            <Brands Data={brand} parentCallback={callBackFunction}/>
                            {/* <Variant Data={null}/> */}
                            </div>
                    </div>

                    <div className="col-10 p-0 align-items-stretch filter p-0" id="filter">
                        <div className="row m-0 pading-box-rigth">
                            <div className="d-flex bg-gray-500 py-2 justify-content-between fs-12 filter-tool-bar w-100">
                                <div className="d-flex align-items-center count-item">
                                    <span>Kết quả tìm kiếm cho từ khoá: <strong>{param}</strong></span>
                                </div>
                                <div className="d-flex text-color">
                                    
                                </div>
                            </div>
                            { 
                                productList.length > 0 ?(
                                    productList?.map((item, index)=>(
                                        <div className="col-sm-6 col-md-4 col-lg-3 p-0 mb-3">
                                            <ItemDefaultV2 key={index} item={item} index={index} showPriceRow='true' showpercen='false'/>
                                        </div>
                                    ))
                                ):(
                                    showAlert ===true && productList.length === 0 ?(
                                        <div className='message pdr-10'>
                                            <div className='info'>
                                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> <span>Không có sản phẩm phù hợp.</span>
                                            </div>
                                            
                                        </div>
                                    ):(<div id="landing-web">
                                    <div className="loading-page"  style={{textAlign:"center"}}>
                                        <img src="/../images/loading.gif" alt="icon"/>
                                    </div>
                                </div>)
                                    
                                    // <div>Chưa có dữ liệu</div>
                                )
                                
                            }
                            <div className="col-12 p-0 my-4">
                            {
                                metadata?.total_page > 1 ?(
                                    <div className="d-flex justify-content-center pagination">
                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel='›'
                                            onPageChange={handlePageChange}
                                            pageRangeDisplayed={2}
                                            pageCount={metadata?.total_page}
                                            previousLabel="‹"
                                            renderOnZeroPageCount={null}
                                        />
                                    </div> 
                                ):(null)
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
export default Search;